import { RefObject, useEffect, useEffectEvent } from 'react'

export const useClickOutside = <T extends HTMLElement = HTMLElement>(ref: RefObject<T | null>, handler: (event: Event) => void) => {
    const onClickOutside = useEffectEvent(handler)

    useEffect(() => {
        const listener = (event: Event) => {
            const el = ref.current
            const target = event.target as Node | null
            if (!el || el.contains(target)) return
            onClickOutside(event)
        }

        document.addEventListener('pointerdown', listener)

        return () => {
            document.removeEventListener('pointerdown', listener)
        }
    }, [ref])
}
